(() => {
  const RPM_LABEL = 'rpm';
  const MOTOR_LABEL = 'motor';
  let scheduled = false;

  function normalizeLabel(value) {
    return String(value || '')
      .trim()
      .toLocaleLowerCase('es-CL');
  }

  function formatRpmValue(value, keepUnit = false) {
    const raw = String(value || '').trim();

    if (!raw || raw === '—') {
      return raw;
    }

    const numericText = raw
      .replace(/rpm/gi, '')
      .replace(/\./g, '')
      .replace(/\s/g, '')
      .replace(/[^0-9]/g, '');

    if (!numericText) {
      return raw;
    }

    const number = Number(numericText);

    if (!Number.isFinite(number)) {
      return raw;
    }

    const formatted = number.toLocaleString('es-CL');
    return keepUnit ? `${formatted} RPM` : formatted;
  }

  function formatMotorValue(value) {
    const raw = String(value || '').trim();

    if (!raw || raw === '—') {
      return raw;
    }

    const cleaned = raw.replace(/^motor\s+/i, '').trim();

    if (/^rotativo$/i.test(cleaned)) {
      return 'Rotativo';
    }

    if (/^vectorial$/i.test(cleaned)) {
      return 'Vectorial';
    }

    return cleaned;
  }

  function setTextIfChanged(element, value) {
    if (!element || element.textContent.trim() === value) {
      return;
    }

    element.textContent = value;
  }

  function refineProductSpecifications(root = document) {
    root
      .querySelectorAll('.bm-product-specification__row')
      .forEach((row) => {
        const label = row.querySelector('.bm-product-specification__label');
        const value = row.querySelector('.bm-product-specification__value');

        if (!label || !value) {
          return;
        }

        const normalizedLabel = normalizeLabel(label.textContent);

        if (normalizedLabel === RPM_LABEL) {
          setTextIfChanged(value, formatRpmValue(value.textContent));
        }

        if (normalizedLabel === MOTOR_LABEL) {
          setTextIfChanged(value, formatMotorValue(value.textContent));
        }
      });
  }

  function refineComparator(root = document) {
    root
      .querySelectorAll('table[data-comparison-table] tr')
      .forEach((row) => {
        const cells = Array.from(row.children);

        if (cells.length < 2) {
          return;
        }

        const normalizedLabel = normalizeLabel(cells[0].textContent);

        if (normalizedLabel === RPM_LABEL) {
          cells.slice(1).forEach((cell) => {
            setTextIfChanged(cell, formatRpmValue(cell.textContent));
          });
        }

        if (normalizedLabel === MOTOR_LABEL) {
          cells.slice(1).forEach((cell) => {
            setTextIfChanged(cell, formatMotorValue(cell.textContent));
          });
        }
      });
  }

  function refineHero(root = document) {
    root.querySelectorAll('[data-bm-active-rpm]').forEach((value) => {
      setTextIfChanged(value, formatRpmValue(value.textContent, true));
    });
  }

  function refineAll(root = document) {
    refineProductSpecifications(root);
    refineComparator(root);
    refineHero(root);
  }

  function scheduleRefine() {
    if (scheduled) {
      return;
    }

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      refineAll(document);
    });
  }

  function initialize() {
    refineAll(document);

    const observer = new MutationObserver((mutations) => {
      const relevantChange = mutations.some((mutation) => {
        if (mutation.type === 'characterData') {
          const parent = mutation.target.parentElement;
          return Boolean(
            parent?.matches('[data-bm-active-rpm]') ||
            parent?.closest('.bm-product-specification__row') ||
            parent?.closest('table[data-comparison-table]')
          );
        }

        return Array.from(mutation.addedNodes).some((node) => {
          if (!(node instanceof HTMLElement)) {
            return false;
          }

          return Boolean(
            node.matches?.('[data-bm-active-rpm], .bm-product-specification__row, table[data-comparison-table], tr') ||
            node.querySelector?.('[data-bm-active-rpm], .bm-product-specification__row, table[data-comparison-table]')
          );
        });
      });

      if (relevantChange) {
        scheduleRefine();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', scheduleRefine);
})();